import { FC } from "react";


import { ServicesTechAdvicePageId } from "utils/useScroll";
import { Box } from "@chakra-ui/react";
import { AiOutlineAudit } from "react-icons/ai";
import { GrDocumentPerformance } from "react-icons/gr";
import { TbAugmentedReality } from "react-icons/tb";

import DeliverablesSection from "./Deliverables";

import ServiceDescriptor from "./ServiceDescriptor";
import NextStepsSection from "./NextSteps";
import { FaBug, FaChartBar, FaProjectDiagram, FaMoneyBillWave } from "react-icons/fa";


export const TechAdviceService: FC = () => {

 const label =  "Technical Advice";
  const title = "Architecture Validation & Stress Testing Service";
  const footer = "Expert architecture validation to stress-test your designs, expose hidden risks, and future-proof your systems before they hit production";
  const services = [
    {
      title: "Comprehensive Architecture & Design Audit",
      icon: AiOutlineAudit,
      items: [
        "Technical Soundness: Validate architectural patterns against your specific requirement",
        "Failure Mode Analysis: Identify single points of failure and cascade risk",
        "Cost Efficiency: Spot over/under-provisioning in resource allocation",
        "Tech Debt Assessment: Flag design compromises that may complicate future evolution"
        ]
    },
    {
      title: "Scalability Stress Test",
      icon: GrDocumentPerformance,
      items: [
        "Load modeling for projected 3-5x growth scenarios",
        "Bottleneck identification in data flows and service dependencies",
        "Concurrency and contention analysis",
        "State management and caching strategy evaluation"
      ]
    },
    {
      title: "Operational Reality Check",
      icon: TbAugmentedReality,
      items: [
        "Deployment complexity assessment",
        "Monitoring and troubleshooting readines",
        "Disaster recovery preparednes",
        "Security and compliance alignment"
            ]
    }
    
  ];
  return (
    <Box id={ServicesTechAdvicePageId}>
      <ServiceDescriptor title={title} label={label} footer={footer} services={services} nextRoute="/orgs" prevRoute="/analytics"/>
      <DeliverablesSection deliverables={[
            {
              icon: FaBug,
              title: "Risk Assessment Report",
              description: "Prioritized list of vulnerabilities with severity ratings",
              tags: ["Critical/High/Medium"]
            },
            {
              icon: FaChartBar,
              title: "Performance Simulation",
              description: "Load test results at 3x/5x/10x current traffic",
              tags: ["Metrics", "Benchmarks"]
            },
            {
              icon: FaProjectDiagram,
              title: "Architecture Blueprint",
              description: "Future-state diagram with upgrade pathways",
              tags: ["Visio", "Draw.io"]
            },
            {
              icon: FaMoneyBillWave,
              title: "Cost Optimization Plan",
              description: "Infrastructure savings opportunities (30/60/90 day)",
              tags: ["ROI Analysis"]
            }
          ]} />
    <NextStepsSection title="Ready to Strengthen Your Architecture?" 
      message="Take the next step toward bulletproof system design" 
      actionHeading="Schedule Consultation" 
      actionText="Book a 90-minute discovery session to discuss your specific challenges" 
      actionLabel="Contact Me and Book Today"/>
      
    </Box>

  );
  
}
export default TechAdviceService;
